export const neutronUrl = import.meta.env.VITE_NEUTRON_URL;

export const lunaUrl = import.meta.env.VITE_LUNA_URL;

export const personaEnvironmentId = import.meta.env.VITE_PERSONA_ENVIRONMENT_ID;

export const environment = import.meta.env.MODE.toLowerCase().includes('production')
  ? 'production'
  : 'development';

export function getSenderPhoneNumber() {
  const senderPhoneNumber = import.meta.env.VITE_SENDER_PHONE_NUMBER;

  if (!senderPhoneNumber) {
    throw new Error('SENDER_PHONE_NUMBER is not defined');
  }

  return senderPhoneNumber;
}

function getUnleashUrl() {
  const neutronUrlValue = import.meta.env.VITE_NEUTRON_URL;
  if (!neutronUrlValue) {
    throw new Error('NEUTRON_URL is not defined');
  }

  return new URL('/feature-flag/proxy', neutronUrlValue).toString();
}

export const unleashConfig = {
  url: getUnleashUrl(),
  appName: 'opendock-nova',
  // Comet is unauthenticated and reads flags through Neutron's feature-flag proxy, which
  // ignores this value. It still has to be a non-empty string without an Unleash token
  // prefix: unleash-proxy-client throws on an empty clientKey and would infer the
  // environment from a `<project>:<environment>.<hash>` token.
  clientKey: 'neutron-proxy',
  environment
};
